import React from 'react';

const Poll = ({ config, locale, queryParams }) => (
	<div>Poll</div>
);

Poll.defaultProps = {};

export default Poll;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/poll/Poll.component.js